<script setup>
import { defineAsyncComponent } from 'vue'
import BaseWave from '@/components/general/BaseWave.vue'

const FooterHead = defineAsyncComponent(() => import('./FooterHead.vue'))
const FooterBody = defineAsyncComponent(() => import('./FooterBody.vue'))
const FooterBottom = defineAsyncComponent(() => import('./FooterBottom.vue'))
const FooterCustomerCare = defineAsyncComponent(() => import('./FooterCustomerCare.vue'))

const scrollUp = () => { window.scrollTo({ top: 0, behavior: 'smooth' }) };
</script>

<template>
  <div class="c-mt-auto" />
  <BaseWave
    color="text-primary"
    path="footer"
    class="relative"
  />
  <footer class="footer relative c-pt-6 bg-primary">
    <span
      class="footer__scrollup c-lg:hidden btn c-p-2 text-light c-rounded-circle shadow-none bg-primary"
      aria-label="Scroll up"
      @click="scrollUp"
    >
      <i class="mi-arrow-u icon-20" />
    </span>
    <div class="container c-px-4 c-sm:c-px-0">
      <FooterHead />
      <FooterBody />
      <hr class="bg-light c-mt-6 c-mb-6">
      <FooterCustomerCare />
      <hr class="bg-light c-mt-4 c-mb-4">
      <FooterBottom />
    </div>
  </footer>
</template>